import React, { FC , useEffect , useState } from "react";
import { Modal, Row, Col, Table } from "antd";
import { useGlobalState } from "../../context/Provider";
import { GetProductList } from "../../api/product";
import { filterParams } from "../../helpers/function.helper";
import { generalconditioncolumn , productdatahelper } from "../../helpers/products.helper";

interface GeneralConditionProductModalProps {
  visible: boolean;
  setVisible: (value: boolean) => void;
  info: any;
  setInfo: (value: object) => void;
  
}

const GeneralConditionProductModal: FC<GeneralConditionProductModalProps> = (
  props
) => {
  
  const { visible, setVisible, info  , setInfo}: any = props;
  const [loading, setLoading] = useState<boolean>(true);
  const [data, setData] = useState<any>([]);
  const { langState }: any = useGlobalState();


  useEffect(() => {
    handleGetProductList();
  }, [info ]);
 


  const handleGetProductList = () => {
    setLoading(true)
    const params = {
      ProductName: info,
    };
    const fp = filterParams(params);
    GetProductList(fp).then((res: any) => {
      setLoading(false);
      if (res.status === 200) {
        setData(productdatahelper(res.data.items, 1));
      }
    });
  };
  
  const handleCancel = () =>{
    setData([]);
    setVisible(false);
    setInfo(null)

  }
  

  return (
    <Modal
      title={
        langState.locale === "en-US" ? "وضعیت کلی محصول" : "وضعیت کلی محصول"
      }
      visible={visible}
      width={1250}
      style={{ top: 10 }}
      onCancel={handleCancel}
     
    >
      <Row gutter={[24, 24]}>
        <Col span={24}>
          <Table
          columns={generalconditioncolumn()}
          dataSource={data}
          size="middle"
          pagination={false}
          scroll={{ x: 1100, y: "calc(100vh - 310px)" }}
          loading={loading}
         
        />
        </Col>
      </Row>
    </Modal>
  );
};

export default GeneralConditionProductModal;
